import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton,} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useEffect, useState} from "react";
import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material";
import {TitleWithOutStarIcon, TitleWithStarIcon} from "../../../../components/tittle_with_star_icon";
import {
    CommonDecimalTextField,
    CommonEmailTextField,
    CommonPhoneNumberTextField,
    CommonTextField
} from "../../../../components/commonTextField";
import {FullButton} from "../../../../components/button/common_button";
import {
    driverDetailsApiCall,
    existingTaskListApiCall,
    individualLocationDetailsApi
} from "../../../controllers/pick_up_order_controller";
import CommonColorUtils from "../../../../utils/common_colors";
import Skeleton from "@mui/material/Skeleton";
import {ExistingTaskListModel} from "../../../models/existing_task_list_model";
import ExistingTaskDropdown from "./existing_task_dropdown";
import {LocationDetailsModel} from "../../../models/location_detail_model";
import {AddToExistingModel, Location} from "../../../models/add_to_existing_model";
import AssignedDriverDropdown from "../create_task/assigned_driver_dropdown";
import {DriverListModel} from "../../../models/driver_list_model";


export function AddToExistingDialog({
                                        isDialogOpen,
                                        handleCloseDialog,
                                        selectedCpAwbs,
                                        taskType,
                                        hubId,
                                        hubName,
                                        selectedHub,
                                        handleAddToExistingButton,
                                        selectedOrderCount

                                    }) {
    let firstRender = true;


    const [isApiCall, setApiCall] = useState(false);
    const [selectedOrderCountWithType, setSelectedOrderCountWithType] = useState('');
    const [existingTaskList, setExistingTaskList] = useState([]);
    const [existingShipmentCount, setExistingShipmentCount] = useState('');
    const [locationName, setLocationName] = useState('');
    const [vendorName, setVendorName] = useState('');
    const [locationAddress, setLocationAddress] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedExistingTask, setSelectedExistingTask] = useState(null);
    const [email, setEmail] = useState("");
    const [hour, setHour] = useState(0);
    const [min, setMin] = useState(0);
    const [amPmText, setAmPmText] = useState("AM");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [postalArea, setPostalArea] = useState("");
    const [locationDetail, setLocationDetail] = useState(null);
    const [driverList, setDriverList] = useState([]);
    const [isDriverEditable, setIsDriverEditable] = useState(true);


    const fetchExistingTaskDetailsList = async () => {
        try {
            setApiCall(true);
            const response = await existingTaskListApiCall(taskType, hubId);
            if (response) {
                const existingTaskListModel = ExistingTaskListModel.fromJson(response);
                setExistingTaskList(existingTaskListModel.taskList ?? []);
            }
        } catch (e) {
            console.error(e);
            setExistingTaskList([]);
        } finally {
            setApiCall(false);
        }
    };

    const fetchDriverDetailsList = async () => {
        try {
            setApiCall(true);
            const response = await driverDetailsApiCall(hubId);
            if (response) {
                const driverListModel = DriverListModel.fromJson(response);
                setDriverList(driverListModel.results ?? []);
            }
        } catch (e) {
            setDriverList([]);
        } finally {
            setApiCall(false);
        }
    };

    const getIndividualLocationDetailsApiUrl = async (locationId) => {
        try {
            setApiCall(true);
            const response = await individualLocationDetailsApi(locationId);
            if (response) {
                return LocationDetailsModel.fromJson(response);
            }

        } catch (e) {

        } finally {
            setApiCall(false);
        }
    }


    const fetchData = async () => {
        try {
            await fetchExistingTaskDetailsList();
            await fetchDriverDetailsList();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleDriverDropdownChange = (e) => {
        const dropDownValue = e.target.value;
        driverList.forEach((driver) => {

            if (driver.name === dropDownValue) {
                setSelectedDriver(driver);
                return;
            }
        });
    }


    useEffect(() => {
        if (firstRender) {
            setSelectedExistingTask(null);
            setSelectedOrderCountWithType("");
            setExistingShipmentCount("");
            setSelectedDriver(null);
            setIsDriverEditable(true)
            if (taskType?.toLowerCase() === 'forward') {
                setSelectedOrderCountWithType(`PICKUP (${selectedCpAwbs.length})`);
            } else if (taskType?.toLowerCase() === 'return') {
                setSelectedOrderCountWithType(`RETURN (${selectedCpAwbs.length})`);
            } else if (taskType?.toLowerCase() === 'rto') {
                setSelectedOrderCountWithType(`RTO (${selectedCpAwbs.length})`);
            }

            fetchData();
        }
        firstRender = false;

    }, [isDialogOpen,selectedCpAwbs.length]);

    const handleExistingDropdownChange = async (e) => {
        const dropDownValue = e.target.value;
        let locationId = '';


        setExistingShipmentCount("");
        setSelectedDriver(null);
        setIsDriverEditable(true);
        setLocationName("");
        setVendorName("");
        setLocationAddress("");
        setPhoneNumber("");
        setLatitude("");
        setLongitude("");
        setEmail("");
        setHour(6);
        setMin(0);
        setAmPmText("AM");
        setPostalArea("");

        for (const existingTask of existingTaskList) {

            if (existingTask.taskName === dropDownValue) {
                setSelectedExistingTask(existingTask);
                let tmpExistingShipmentCount = taskType?.toLowerCase() === 'forward' ?
                    "pickup".toUpperCase() + ` ${existingTask.orderCount.slice(existingTask.orderCount.indexOf("("))}` :
                    taskType.toUpperCase() + ` ${existingTask.orderCount.slice(existingTask.orderCount.indexOf("("))}`
                ;
                setExistingShipmentCount(tmpExistingShipmentCount);
                driverList.forEach((driver) => {
                    if (driver.name === existingTask.driver) {
                        setSelectedDriver(driver);
                        setIsDriverEditable(false);
                        return;
                    }
                })

                locationId = existingTask.locationId;
                const locationDetails = await getIndividualLocationDetailsApiUrl(locationId);

                setLocationDetail(locationDetails);

                setLocationName(locationDetails?.locationName ?? "");
                setVendorName(locationDetails?.vendorName ?? "");
                setLocationAddress(locationDetails?.locationAddress ?? "");
                setPhoneNumber(locationDetails?.phoneNumber ?? "");
                setLatitude(locationDetails?.latitude ?? "");
                setLongitude(locationDetails?.longitude ?? "");
                setCountry(locationDetails?.countryName ?? "");
                setCity(locationDetails?.city ?? "");
                setPostalArea(locationDetails?.postalArea ?? "");

                const emailList = locationDetails?.email.split(",");

                if (emailList.length !== 0) {
                    setEmail(emailList[0]);
                } else {
                    setEmail("");
                }

                let [hours, min] = locationDetails?.pickupTime.split(":");

                let hour = parseInt(hours);

                let amOrPm = hour < 12 ? "AM" : "PM";

                let stringHour;

                if (hour === 12 && amOrPm === "PM") {
                    stringHour = `${hour}`;
                } else {
                    stringHour = `${hour % 12}`;
                }

                if (stringHour < 10) {
                    stringHour = `0${stringHour}`; /// if the hour value
                }

                setHour(stringHour);
                setMin(min);
                setAmPmText(amOrPm);

                continue;
            }
        }
    }


    const skeleton =
        (<Skeleton height={"90px"} sx={{marginBottom: "0px", marginTop: "-15px"}}/>);


    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            sx={{
                "& .MuiDialog-paper": {
                    width: "800px",
                    maxHeight: "600px",
                },
            }}
        >
            <DialogTitle>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <span
                        style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            fontFamily: "Inter, Arial, sans-serif",
                        }}>   {"Add to Existing"}</span>
                    <div onClick={handleCloseDialog}>
                        <CloseIcon
                            style={{width: "24px", height: "24px", cursor: "pointer"}}
                        />
                    </div>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Selected Order Type & Count"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Select Task"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <CommonTextField
                                label=""
                                inputValue={selectedOrderCountWithType}
                                onHandleChange={() => {
                                }}
                                disabled={true}
                                sx={{marginTop: "5px", marginBottom: "15px"}}
                            />}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <ExistingTaskDropdown options={existingTaskList} onChange={handleExistingDropdownChange}
                                                  selectedValue={selectedExistingTask?.taskName} sx={{
                                marginBottom: "15px",
                            }}/>}
                    </Grid>

                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <TitleWithStarIcon title={"Existing Shipments"}/>

                    </Grid>

                    <Grid item xs={6}>
                        <TitleWithOutStarIcon title={"Assign Driver"}/>

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <CommonTextField
                                label=""
                                inputValue={existingShipmentCount}
                                disabled={true}
                                sx={{marginTop: "5px", marginBottom: "15px"}}
                            />}
                    </Grid>

                    <Grid item xs={6}>
                        {isApiCall ? skeleton :
                            <AssignedDriverDropdown options={driverList} onChange={handleDriverDropdownChange}
                                                    isDisable={!isDriverEditable}
                                                    selectedValue={selectedDriver?.name} sx={{
                                marginBottom: "15px",
                            }}/>
                        }
                    </Grid>

                </Grid>

                {selectedExistingTask && (<>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Location"}/>

                        </Grid>

                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {isApiCall ? skeleton :
                                <CommonTextField
                                    label=""
                                    inputValue={locationName}
                                    disabled={true}
                                    sx={{marginTop: "5px", marginBottom: "15px"}}
                                />}
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Location Name"}/>

                        </Grid>

                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Vendor Name"}/>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {isApiCall ? skeleton :
                                <CommonTextField
                                    label=""
                                    inputValue={locationName}
                                    disabled={true}
                                    sx={{marginTop: "5px", marginBottom: "15px"}}
                                />}

                        </Grid>

                        <Grid item xs={6}>
                            {isApiCall ? skeleton : <CommonTextField
                                label=""
                                inputValue={vendorName}
                                disabled={true}
                                sx={{marginBottom: "15px", marginTop: "5px"}}
                            />}

                        </Grid>
                    </Grid>
                    <TitleWithStarIcon title={"Location Address"}/>
                    {isApiCall ? skeleton :
                        <CommonTextField
                            label=""
                            inputValue={locationAddress}
                            disabled={true}
                            sx={{marginBottom: "15px", marginTop: "5px"}}
                        />}
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Country"}/>

                        </Grid>

                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"City"}/>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {isApiCall ? skeleton :
                                <CommonTextField
                                    label=""
                                    inputValue={country}
                                    disabled={true}
                                    sx={{marginTop: "5px", marginBottom: "15px"}}
                                />}
                        </Grid>

                        <Grid item xs={6}>
                            {(isApiCall) ? skeleton :
                                <CommonTextField
                                    label=""
                                    inputValue={city}
                                    disabled={true}
                                    sx={{marginTop: "5px", marginBottom: "15px"}}
                                />}
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithOutStarIcon title={"Area/Postal Code"}/>

                        </Grid>

                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Phone No."}/>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {(isApiCall) ? skeleton :
                                <CommonTextField
                                    label=""
                                    inputValue={postalArea}
                                    disabled={true}
                                    sx={{marginTop: "5px", marginBottom: "15px"}}
                                />}
                        </Grid>

                        <Grid item xs={6}>
                            {isApiCall ? skeleton : <CommonPhoneNumberTextField
                                label=""
                                inputValue={phoneNumber}
                                disabled={true}
                                sx={{marginTop: "5px", marginBottom: "5px"}}
                            />}
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Latitude"} marginTop={"10px"}/>

                        </Grid>

                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Longitude"} marginTop={"10px"}/>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {isApiCall ? skeleton : <CommonDecimalTextField
                                label=""
                                inputValue={latitude}
                                disabled={true}
                                sx={{marginTop: "5px"}}
                            />}
                        </Grid>

                        <Grid item xs={6}>
                            {isApiCall ? skeleton : <CommonDecimalTextField
                                label=""
                                inputValue={longitude}
                                disabled={true}
                                sx={{marginTop: "5px"}}
                            />}
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Email"} marginTop={"10px"}/>

                        </Grid>

                        <Grid item xs={6}>
                            <TitleWithStarIcon title={"Pickup Time"} marginTop={"10px"}/>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            {isApiCall ? skeleton : <CommonEmailTextField
                                label=""
                                inputValue={email}
                                disabled={true}
                                sx={{marginTop: "10px", marginBottom: "15px"}}
                            />}
                        </Grid>

                        {isApiCall ? <Grid item xs={6}>
                            {skeleton}
                        </Grid> : <>
                            <Grid item xs={1.8}>
                                <CommonPhoneNumberTextField
                                    label="Hour"
                                    inputValue={hour}
                                    maxLength={2}
                                    disabled={true}
                                    sx={{marginTop: "0px"}}
                                />
                            </Grid>
                            <Grid item xs={1.8}>
                                <CommonPhoneNumberTextField
                                    label="Minute"
                                    inputValue={min}
                                    maxLength={2}
                                    disabled={true}
                                    sx={{marginTop: "0px"}}
                                />
                            </Grid>
                            <Grid item xs={2.4}>
                                <CommonEmailTextField
                                    label=""
                                    inputValue={amPmText}
                                    otherProps={{readOnly: true}}
                                    sx={{marginTop: "0px"}}
                                    disabled={true}
                                    endAdornmentIcons={
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                            }}
                                        >
                                            <IconButton
                                                size="small"

                                                style={{paddingTop: "20px", paddingRight: "5px"}}
                                                disabled={true}
                                            >
                                                <ArrowDropUp/>
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                style={{paddingBottom: "20px"}}
                                                disabled={true}
                                            >
                                                <ArrowDropDown/>
                                            </IconButton>
                                        </div>
                                    }
                                />

                            </Grid>
                        </>}
                    </Grid>

                </>)
                }

            </DialogContent>
            <DialogActions>
                <div style={{display: "flex", gap: "10px", marginRight: "10px"}}>
                    <button
                        style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            width: "120px",
                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                            height: 48,
                        }}
                        onClick={handleCloseDialog}
                    >
            <span style={{fontWeight: 600, fontSize: "14px", color: "black"}}>
              Cancel
            </span>
                    </button>

                    <FullButton
                        buttonText={"Add To Existing"}
                        activeColor={CommonColorUtils.primaryMainBlue}
                        inactiveColor={CommonColorUtils.primaryMainBlueDisabledColor}
                        buttonTextColor={CommonColorUtils.primaryKWhite}
                        active={selectedExistingTask}
                        height={"48px"}
                        width={"180px"}
                        customCursor={"pointer"}
                        isDisable={!selectedExistingTask}
                        handleOnPress={
                            () => {
                                const addToExistingModel = new AddToExistingModel();
                                const location = new Location();
                                location.type = "";
                                location.vendorName = locationDetail?.vendorName;
                                location.vendorId = locationDetail?.vendorId;
                                location.email = email;
                                location.id = locationDetail?.id;
                                location.name = locationDetail?.locationName;
                                location.address = locationDetail?.locationAddress;
                                location.country = locationDetail?.countryCode;
                                location.countryId = locationDetail?.countryId;
                                location.city = locationDetail?.city;
                                location.cityId = locationDetail?.cityId;
                                location.area = locationDetail?.postalArea;
                                location.lat = locationDetail?.latitude;
                                location.lng = locationDetail?.longitude;
                                location.pickupTime = locationDetail?.pickupTime;
                                location.phoneCode = locationDetail?.phoneCode;
                                location.phoneNumber = locationDetail?.phoneNumber;
                                location.originHubId = locationDetail?.originHubId || hubId;
                                location.returnHubId = locationDetail?.returnHubId || hubId;
                                location.originHub = locationDetail?.originHubName || hubName;
                                location.returnHub = locationDetail?.returnHubName || hubName;
                                location.returnInfoName = locationDetail?.returnInfoName;
                                location.landmark = locationDetail?.landmark;
                                addToExistingModel.location = location;
                                addToExistingModel.orders = [...selectedCpAwbs];
                                addToExistingModel.driverName = selectedDriver?.name || null;
                                addToExistingModel.driverId = selectedDriver?.id || null;
                                addToExistingModel.driverEmail = selectedDriver?.email || null;

                                handleAddToExistingButton(addToExistingModel, selectedExistingTask);
                            }
                        }
                    />
                </div>
            </DialogActions>
        </Dialog>
    );
}
